var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('language-selector', _vm._b({ attrs: { "language": _vm.languageModel, "language-lists": _vm.config.field.options || [] }, on: { "update:language": function updateLanguage($event) {
        _vm.languageModel = $event;
      } } }, 'language-selector', _vm.config.field, false));
};
var staticRenderFns = [];

export { render, staticRenderFns };